module.exports = __webpack_public_path__ + "static/img/c1.249fe0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/c1.png
// module id = nQkK
// module chunks = 16